import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import OrderSummaryLine from 'JS/components/order/OrderSummaryLine.vue';
import { computed } from 'vue';
import { getThumbnailFromCardType } from 'JS/utilities/payment';
import { ICheckoutPayment } from 'JS/types/Checkout';
import { IWorkOrderConfirmationResource } from 'JS/types/Automotive';
import { WorkOrderTotalType } from 'JS/automotive/auto-service-scheduler/types/session';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentPayment',
  props: {
    workOrder: null
  },
  setup(__props: any) {

const props = __props as {
	workOrder: IWorkOrderConfirmationResource;
}



const paymentMethods = computed<ICheckoutPayment[]>(() => {
	const defaultPaymentMethods = (props.workOrder?.paymentInfo?.paymentMethods ?? []).slice(); // copy to prevent mutation by sort
	// Move gift cards to the end
	return defaultPaymentMethods.sort((_a, b) => b.cardType === 'GiftCard' ? -1 : 1);
});

const total = computed(() =>  props.workOrder?.workOrderSummary?.total);
const amountPaid = computed(() => {
	switch (total.value?.type) {
		case WorkOrderTotalType.Normal:
			return total.value.amount;
		case WorkOrderTotalType.TBD:
		default:
			return null;
	}
});

function getPaymentThumbnail(payment: ICheckoutPayment) {
	return getThumbnailFromCardType(payment.cardType, { useFullPayPalThumbnail: true });
}

return { __sfc: true,props, paymentMethods, total, amountPaid, getPaymentThumbnail, Icon, OrderSummaryLine }
}

})